import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../../assets/image/logo.png';
import _imports_1 from '../../assets/image/986df80d8db380a45dab809fcac129b7.jpg';
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "header_date"
};
const _hoisted_4 = {
  class: "img"
};
const _hoisted_5 = {
  key: 0,
  class: "banner-container"
};
import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { isWeChat } from '@/utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {
    const router = useRouter();
    const handleSelect = item => {
      // console.log(router);
      // console.log(item);
      router.push({
        path: item
      });
    };
    // 计算属性返回格式化后的日期
    const formattedDate = computed(() => {
      const targetDate = ref(new Date());
      const year = targetDate.value.getFullYear();
      const month = targetDate.value.getMonth() + 1;
      const day = targetDate.value.getDate();
      const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
      const dayOfWeek = targetDate.value.getDay();
      return `${year}年${month}月${day}日 星期${weekDays[dayOfWeek]}`;
    });
    // 微信浏览器兼容性处理
    onMounted(() => {
      if (isWeChat) {
        console.log('检测到微信浏览器环境，已应用兼容性修复');
        // 添加微信浏览器标识类名，便于CSS特殊处理
        document.body.classList.add('wechat-browser');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(formattedDate.value), 1)])]), _cache[29] || (_cache[29] = _createElementVNode("div", {
        class: "logo-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "alg",
        class: "logo-image"
      })], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_menu, {
        class: "el-menu-demo",
        mode: "horizontal",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("首页", -1)]))]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "2"
        }, {
          title: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("公司概况", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/gsjj"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("公司简介", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/jgsz"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("机构设置", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/ryzz"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("荣誉资质", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/lxwm"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("联系我们", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "3"
        }, {
          title: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("成果转化", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/qyxq"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("企业需求", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/zxfw"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("咨询服务", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/jsjlr"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("技术经理人", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "4"
        }, {
          title: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("科技创新", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/product"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("主要产品", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/zscq"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("知识产权", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/zszx"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("中试中心", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/jyjczx"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("检验检测", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "5"
        }, {
          title: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("企业孵化", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/zhyq"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("智慧园区", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/hpkf"
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("湖畔咖啡", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/kjjlzx"
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("科技交流中心", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/cyhd"
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("创业活动", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/cyds"
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("创业导师", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/zccx"
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("政策查询", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/wyrz"
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("我要入驻", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/cxcyqy"
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("创新创业企业", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/trzfw"
        }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("投融服务", -1)]))]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "7"
        }, {
          title: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("党群园地", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/dqly"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("党建动态", -1)]))]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/stsg"
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("省图书驿站", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _unref(router).currentRoute.value.name == 'home' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[28] || (_cache[28] = [_createElementVNode("img", {
        src: _imports_1,
        alt: "alg",
        class: "banner-image"
      }, null, -1)]))])) : _createCommentVNode("", true)], 64);
    };
  }
});